import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-add-stock-modal',
  templateUrl: './add-stock-modal.component.html',
  styleUrls: ['./add-stock-modal.component.scss']
})
export class AddStockModalComponent implements OnInit {
  addStockForm:FormGroup = this.fb.group({
    stock:['',[Validators.required, Validators.pattern(/^[0-9]*$/)]],
    foc:['',[Validators.required, Validators.pattern(/^[0-9]*$/)]],
    isResetEmptyBox:[false]
  })
  @Output() event = new EventEmitter<number>();

  constructor(private fb:FormBuilder, public bsModalRef: BsModalRef) { }

  ngOnInit() {
  }

  handleModalHide() {
    this.bsModalRef.hide();
  }

  onContinue(){
    this.event.emit(this.addStockForm.value);
    this.handleModalHide();
  }

}
